import { Button } from "PFComponents/button";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import ColorPicker from "./color_picker";
import css from "./export_tab.module.scss";
import Preview from "./preview";

const ExportTab = ({
  exportableProfiles,
  index,
  config,
  setConfig,
  downloadCsv,
  handleDownload,
  avatar,
  logo,
  serializedProfile,
  previewMode
}) => {
  const { t } = useTranslation();
  const { exportTemplate } = config;

  const enabledLength = exportableProfiles.countEnabled();
  const allEnabled = enabledLength === exportableProfiles.length;
  const format = `.${exportTemplate}`;

  const renderButtons = () => (
    <div className={css.exportButtons}>
      {exportTemplate === "csv" ? (
        <Button kind="primary" onClick={() => downloadCsv()}>
          {t("export.download.single", { format })}
        </Button>
      ) : (
        <>
          <Button kind="primary" onClick={() => handleDownload()}>
            {t("export.download.single", { format })}
          </Button>
          {enabledLength !== 1 && (
            <Button kind="primary" onClick={() => handleDownload(true)}>
              {allEnabled
                ? t("export.download.all", { format })
                : t("export.download.count", { format, count: enabledLength })}
            </Button>
          )}
        </>
      )}
    </div>
  );

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        {!["csv", "pptx"].includes(config.exportTemplate) && (
          <ColorPicker
            currentColor={config.color}
            handleClick={(color, color2) => setConfig({ ...config, color, color2 })}
          />
        )}
        {!previewMode && renderButtons()}
      </div>
      <Preview
        avatar={avatar}
        logo={logo}
        exportableProfiles={exportableProfiles}
        index={index}
        config={config}
        setConfig={setConfig}
        serializedProfile={serializedProfile}
      />
    </div>
  );
};

ExportTab.propTypes = {
  index: PropTypes.number.isRequired,
  config: PropTypes.object.isRequired,
  setConfig: PropTypes.func.isRequired,
  exportableProfiles: PropTypes.object,
  downloadCsv: PropTypes.func.isRequired,
  handleDownload: PropTypes.func.isRequired,
  logo: PropTypes.object.isRequired,
  avatar: PropTypes.string.isRequired,
  serializedProfile: PropTypes.object.isRequired,
  previewMode: PropTypes.bool
};

export default ExportTab;
